import setResized from './../../helpers/set-resized';

export default () => {

	const itemGrids = document.querySelectorAll('.look__item-grid');

	if (itemGrids) {
		itemGrids.forEach(grid => {

			if (grid.closest('.has-1-looks')) return;

			const picture = grid.querySelector('.look__picture');
			const products = grid.querySelector('.look__products');

			setResized(() => {
				if (window.innerWidth > 729) {
					products.style.height = grid.offsetHeight - picture.offsetHeight - parseFloat(getComputedStyle(picture).marginBottom) + 'px';
				}
				else {
					products.style.height = '';
				}
			});

		});
	}

}